import { colors, styled } from '@mui/material';

export type NumericPaletteColors = {
  [K in keyof typeof colors]: (typeof colors)[K] extends { 50: string }
    ? (typeof colors)[K]
    : never;
}[keyof typeof colors];

export type PaletteShade = keyof NumericPaletteColors;

export type ColorValue = NumericPaletteColors[keyof NumericPaletteColors];

export const GradientText = styled('span')<{
  colorStart?: ColorValue;
  colorEnd?: ColorValue;
}>`
  background: linear-gradient(
    135deg,
    ${({ colorStart }) => colorStart ?? colors.blue[600]} 0%,
    ${({ colorEnd }) => colorEnd ?? colors.blue[400]} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
